import { render, staticRenderFns } from "./recursion-table-column.vue?vue&type=template&id=347e9df3&"
import script from "./recursion-table-column.vue?vue&type=script&lang=js&"
export * from "./recursion-table-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports